import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type UsedByGroupFieldsFragment = { __typename?: 'UsedByGroup', kind: Types.RecordKind, total: number, hidden: number, hasMore: boolean, refs: Array<{ __typename?: 'UsedByRef', kind: Types.RecordKind, id: string, name: string, status?: string | null, parent?: { __typename?: 'UsedByRef', kind: Types.RecordKind, id: string, name: string } | null }> };

export type GetCategoryUsedByQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CategoryDocumentFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  first: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  kind?: Types.InputMaybe<Types.RecordKind>;
}>;


export type GetCategoryUsedByQuery = { __typename?: 'Query', categories?: { __typename?: 'CategoriesConnection', totalCount: number, nodes?: Array<{ __typename?: 'CategoryDocument', id: string, usedBy?: { __typename?: 'UsedBy', total: number, groups: Array<{ __typename?: 'UsedByGroup', kind: Types.RecordKind, total: number, hidden: number, hasMore: boolean, refs: Array<{ __typename?: 'UsedByRef', kind: Types.RecordKind, id: string, name: string, status?: string | null, parent?: { __typename?: 'UsedByRef', kind: Types.RecordKind, id: string, name: string } | null }> }> } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPriceGroupUsedByQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.PriceGroupDocumentFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  first: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  kind?: Types.InputMaybe<Types.RecordKind>;
}>;


export type GetPriceGroupUsedByQuery = { __typename?: 'Query', priceGroups?: { __typename?: 'PriceGroupsConnection', totalCount: number, nodes?: Array<{ __typename?: 'PriceGroupDocument', id: string, usedBy?: { __typename?: 'UsedBy', total: number, groups: Array<{ __typename?: 'UsedByGroup', kind: Types.RecordKind, total: number, hidden: number, hasMore: boolean, refs: Array<{ __typename?: 'UsedByRef', kind: Types.RecordKind, id: string, name: string, status?: string | null, parent?: { __typename?: 'UsedByRef', kind: Types.RecordKind, id: string, name: string } | null }> }> } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCustomerTypeUsedByQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CustomerTypeDocumentFilterInput>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  first: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  kind?: Types.InputMaybe<Types.RecordKind>;
}>;


export type GetCustomerTypeUsedByQuery = { __typename?: 'Query', customerTypes?: { __typename?: 'CustomerTypesConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomerTypeDocument', id: string, usedBy?: { __typename?: 'UsedBy', total: number, groups: Array<{ __typename?: 'UsedByGroup', kind: Types.RecordKind, total: number, hidden: number, hasMore: boolean, refs: Array<{ __typename?: 'UsedByRef', kind: Types.RecordKind, id: string, name: string, status?: string | null, parent?: { __typename?: 'UsedByRef', kind: Types.RecordKind, id: string, name: string } | null }> }> } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const UsedByGroupFieldsFragmentDoc = new TypedDocumentString(`
    fragment UsedByGroupFields on UsedByGroup {
  kind
  total
  hidden
  hasMore
  refs {
    kind
    id
    name
    status
    parent {
      kind
      id
      name
    }
  }
}
    `, {"fragmentName":"UsedByGroupFields"});
export const GetCategoryUsedByDocument = new TypedDocumentString(`
    query GetCategoryUsedBy($where: CategoryDocumentFilterInput, $limit: Int, $first: Int!, $offset: Int!, $kind: RecordKind) {
  categories(where: $where, first: $limit) {
    nodes {
      id
      usedBy(first: $first, offset: $offset, kind: $kind) {
        total
        groups {
          ...UsedByGroupFields
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment UsedByGroupFields on UsedByGroup {
  kind
  total
  hidden
  hasMore
  refs {
    kind
    id
    name
    status
    parent {
      kind
      id
      name
    }
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetPriceGroupUsedByDocument = new TypedDocumentString(`
    query GetPriceGroupUsedBy($where: PriceGroupDocumentFilterInput, $limit: Int, $first: Int!, $offset: Int!, $kind: RecordKind) {
  priceGroups(where: $where, first: $limit) {
    nodes {
      id
      usedBy(first: $first, offset: $offset, kind: $kind) {
        total
        groups {
          ...UsedByGroupFields
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment UsedByGroupFields on UsedByGroup {
  kind
  total
  hidden
  hasMore
  refs {
    kind
    id
    name
    status
    parent {
      kind
      id
      name
    }
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCustomerTypeUsedByDocument = new TypedDocumentString(`
    query GetCustomerTypeUsedBy($where: CustomerTypeDocumentFilterInput, $limit: Int, $first: Int!, $offset: Int!, $kind: RecordKind) {
  customerTypes(where: $where, first: $limit) {
    nodes {
      id
      usedBy(first: $first, offset: $offset, kind: $kind) {
        total
        groups {
          ...UsedByGroupFields
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment UsedByGroupFields on UsedByGroup {
  kind
  total
  hidden
  hasMore
  refs {
    kind
    id
    name
    status
    parent {
      kind
      id
      name
    }
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCategoryUsedBy: build.query<GetCategoryUsedByQuery, GetCategoryUsedByQueryVariables>({
      query: (variables) => ({ document: GetCategoryUsedByDocument, variables })
    }),
    GetPriceGroupUsedBy: build.query<GetPriceGroupUsedByQuery, GetPriceGroupUsedByQueryVariables>({
      query: (variables) => ({ document: GetPriceGroupUsedByDocument, variables })
    }),
    GetCustomerTypeUsedBy: build.query<GetCustomerTypeUsedByQuery, GetCustomerTypeUsedByQueryVariables>({
      query: (variables) => ({ document: GetCustomerTypeUsedByDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCategoryUsedByQuery, useLazyGetCategoryUsedByQuery, useGetPriceGroupUsedByQuery, useLazyGetPriceGroupUsedByQuery, useGetCustomerTypeUsedByQuery, useLazyGetCustomerTypeUsedByQuery } = injectedRtkApi;
